import { AfterViewInit, ChangeDetectorRef, Component, ContentChild, ElementRef, HostListener, Input, OnChanges, Renderer2, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { UiKitModule } from '../ui-kit.module';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-ui-dropdown',
  standalone: true,
  imports: [
    NgIf,
    UiKitModule,
    NgTemplateOutlet,
  ],
  templateUrl: './ui-dropdown.component.html',
  styleUrl: './ui-dropdown.component.scss',
})
export class UiDropdownComponent implements AfterViewInit {
  @Input() height: number = 0;
  @ViewChild('triggerElement') triggerElement!: ElementRef;  // Reference to the icon (trigger)

  dropdownPosition = {
    left: 0,
    top: 0
  };
  @ViewChild('dropdownPanel') dropdownPanel!: ElementRef;

  @ContentChild('contentTemplate', { static: true }) contentTemplate!: TemplateRef<any>;

  isOpen = false;

  constructor(private cdr: ChangeDetectorRef) {}


  ngAfterViewInit() {
    this.updateDropdownPosition();
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.cdr.detectChanges();
      this.updateDropdownPosition();
    }
  }

  updateDropdownPosition() {
    const triggerRect = this.triggerElement.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const dropdownHeight = this.height;

    const isRtl = getComputedStyle(document.body).direction === 'rtl';
    const offset = 4; // spacing between trigger and dropdown

    // Handle vertical overflow
    let top = triggerRect.top;
    const wouldOverflow = top + dropdownHeight > viewportHeight;
    if (wouldOverflow) {
      top = Math.max(viewportHeight - dropdownHeight - 10, 0); // 10px padding from bottom
    }

    // Set horizontal position based on text direction
    let left: number;
    if (isRtl) {
      // Position dropdown to the left of the trigger
      const dropdownWidth = this.dropdownPanel?.nativeElement.offsetWidth || 200;
      left = triggerRect.left - dropdownWidth - offset;
      if (left < 0) {
        left = 0; // prevent it from going off-screen
      }
    } else {
      // Default LTR: to the right of the trigger
      left = triggerRect.right + offset;
    }

    this.dropdownPosition.left = left;
    this.dropdownPosition.top = top;
  }


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideTrigger = this.triggerElement?.nativeElement.contains(event.target);
    const clickedInsidePanel = this.dropdownPanel?.nativeElement.contains(event.target);

    if (this.isOpen && !clickedInsideTrigger && !clickedInsidePanel) {
      this.isOpen = false;
    }
  }

}
